import type { StockAvailability } from 'product/types/Stock'

interface IsSizeDelayedProps {
	stockAvailability: StockAvailability
	defaultWarehouseId: string
}

export const getIsSizeDelayed = ({
	stockAvailability,
	defaultWarehouseId,
}: IsSizeDelayedProps): boolean =>
	Boolean(
		stockAvailability?.warehouses &&
			!stockAvailability.warehouses.includes(defaultWarehouseId)
	)
